import React from 'react';
import intl from "react-intl-universal";
import classNames from "classnames";

import {useAppState} from "@stores/AppStateContext";

import {formatDayWithMonthAndTime} from "../../../utils/date";
import {getFullNameOrEmpty} from "../../../utils/userHelper";


import './InfoBlockPlain.css';


export interface InfoBlockPlainProps {
    createdBy: string;
    createdAt: string;
    updatedBy?: string;
    updatedAt?: string;
    className?: string;
}

export const InfoBlockPlain = (
    {
        createdBy,
        createdAt,
        updatedBy,
        updatedAt,
        className,
    }: InfoBlockPlainProps
) => {
    const appState = useAppState();
    const usersMap = appState.userState!.usersDS.users
    const createdByUser = usersMap?.get(createdBy);
    const updatedByUser = usersMap?.get(updatedBy);
    return (
        <div className={classNames("InfoBlockPlain body-medium", {[className!]: className})}>
            {createdByUser && (<div className={"InfoBlockPlain__row"}>
                {intl.get('InfoBlockPlain.created.full', {
                    name: getFullNameOrEmpty(createdByUser),
                    date: formatDayWithMonthAndTime(createdAt)
                }).d('Created: {name} on {date}')}
            </div>)}
            {updatedByUser && updatedAt && (
                <div className={"InfoBlockPlain__row"}>
                    {intl.get('InfoBlockPlain.lastEdited.full', {
                        name: getFullNameOrEmpty(updatedByUser),
                        date: formatDayWithMonthAndTime(updatedAt)
                    }).d('Last edited: {name} on {date}')}
                </div>
            )}
        </div>
    )
}
